import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from "../shared/shared.module";
import {CounselingRoutingModule} from "./counseling-routing.module";
import {AddAssessmentComponent} from "./components/add-assessment/add-assessment.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AddIndividualSessionComponent} from "./components/add-individual-session/add-individual-session.component";
import { ViewAssessmentComponent } from './components/view-assessment/view-assessment.component';
import {PrettyJsonModule} from "angular2-prettyjson";
import { AddGroupSessionComponent } from './components/add-group-session/add-group-session.component';
import { IndividualSessionTableComponent } from './components/individual-session-table/individual-session-table.component';
import { GroupSessionTableComponent } from './components/group-session-table/group-session-table.component';
import { AllSessionTablesComponent } from './components/all-session-tables/all-session-tables.component';
import { ViewIndividualAssessmentComponent } from './components/view-individual-assessment/view-individual-assessment.component';
import { ViewGroupSessionComponent } from './components/view-group-session/view-group-session.component';
import { EditIndividualCounselingComponent } from './components/edit-individual-counseling/edit-individual-counseling.component';
import { EditGroupCounselingComponent } from './components/edit-group-counseling/edit-group-counseling.component';
import { EditAssessmentCounselingComponent } from './components/edit-assessment-counseling/edit-assessment-counseling.component';
import {FIREBASE_OPTIONS} from "@angular/fire/compat";
import {environment} from "../../../environments/environment";
import { CounsellingReportDashboardComponent } from './counselling_reporting/counselling-report-dashboard/counselling-report-dashboard.component';
import {
  CounsellingIndividualsReportComponent
} from "./counselling_reporting/counselling-individuals-report/counselling-individuals-report.component";
import {
  CounsellingGroupSessionComponent
} from "./counselling_reporting/counselling-group-session/counselling-group-session.component";
import {
  CounsellingAssessmentReportComponent
} from "./counselling_reporting/counselling-assessment-report/counselling-assessment-report.component";
import { UpcomingDateAssessmentComponent } from './components/assessment-table/upcoming-date-assessment/upcoming-date-assessment.component';
import {CounselingTableComponent} from "./components/assessment-table/counseling-table.component";
import { CounselingChildReportComponent } from './counseling-child-report/counseling-child-report.component';
import {NgxMaterialTimepickerModule} from "ngx-material-timepicker";
import { FollowUpQuestionComponent } from './components/follow-up-question/follow-up-question.component';
import { FollowUpTableComponent } from './components/follow-up-question/follow-up-table/follow-up-table.component';
import { ViewFollowUpAssessmentComponent } from './components/follow-up-question/view-follow-up-assessment/view-follow-up-assessment.component';
import { GraphListHorizontalComponent } from './counseling-child-report/graph-list-horizontal/graph-list-horizontal.component';
import { CounsellingSessionReviewComponent } from './components/CounsellingSessionReview/counselling-session-review/counselling-session-review.component';
import { CounsellingSessionReviewListComponent } from './components/CounsellingSessionReview/counselling-session-review-list/counselling-session-review-list.component';
import {ComponentsModule} from "../shared/components/components.module";
import { WorkUpdateListComponent } from './components/workUpdate/work-update-list/work-update-list.component';
import {AddEditWorkUpdateComponent} from "./components/workUpdate/add-edit-work-update/add-edit-work-update.component";
import { CounsellingSopComponent } from './components/counselling-sop/counselling-sop/counselling-sop.component';
import { AddEditGroupSessionTopicsComponent } from './components/group-session-topics/add-edit-group-session-topics/add-edit-group-session-topics.component';
import { GroupSessionTopicsListComponent } from './components/group-session-topics/group-session-topics-list/group-session-topics-list.component';
import { ViewGroupSessionTopicsComponent } from './components/group-session-topics/view-group-session-topics/view-group-session-topics.component';
import {MatChipsModule} from "@angular/material/chips";
import { CounsellingInductionTableComponent } from './components/counselling-induction/counselling-induction-table/counselling-induction-table.component';
import { AddEditCounsellingHighlightsComponent } from './components/Highlights/add-edit-counselling-highlights/add-edit-counselling-highlights.component';
import { CounsellingHighlightListComponent } from './components/Highlights/counselling-highlight-list/counselling-highlight-list.component';
import { CounsellingInductionListComponent } from './components/counselling-induction/counselling-induction-list/counselling-induction-list.component';
import { AddEditInductionComponent } from './components/counselling-induction/add-edit-induction/add-edit-induction.component';
import { AddRowPopUpComponent } from './components/counselling-induction/add-edit-induction/add-row-pop-up/add-row-pop-up.component';
import { CounsellingCenterLogComponent } from './components/Counselling Centre Log/counselling-center-log/counselling-center-log.component';
import { AddEditCounsellingCentreLogComponent } from './components/Counselling Centre Log/add-edit-counselling-centre-log/add-edit-counselling-centre-log.component';
import { MomTabsComponent } from './components/mom/mom-tabs/mom-tabs.component';
import { MomCounsellorsComponent } from './components/mom/mom-counsellors/mom-counsellors.component';
import { MomManagementComponent } from './components/mom/mom-management/mom-management.component';
import { AddMomCounsellorComponent } from './components/mom/mom-counsellors/add-mom-counsellor/add-mom-counsellor.component';
import { AddMomManagementComponent } from './components/mom/mom-management/add-mom-management/add-mom-management.component';
import { EditRemarkDialogComponent } from './components/Highlights/edit-remark-dialog/edit-remark-dialog.component';
import { ViewCounsellingSessionReviewComponent } from './components/CounsellingSessionReview/view-counselling-session-review/view-counselling-session-review.component';
import { ViewWorkUpdateComponent } from './components/workUpdate/view-work-update/view-work-update.component';
import { MomKavitaComponent } from './components/mom/mom-kavita/mom-kavita.component';
import { AddMomKavitaComponent } from './components/mom/mom-kavita/add-mom-kavita/add-mom-kavita.component';
import { EducationModule } from '../education/education.module';
import { ViewCounsellingInductionComponent } from './components/counselling-induction/view-counselling-induction/view-counselling-induction.component';
import { CounsellingPhotoGalleryComponent } from './counselling-photo-gallery/counselling-photo-gallery.component';

@NgModule({
    declarations: [
        CounselingTableComponent,
        AddAssessmentComponent,
        AddIndividualSessionComponent,
        ViewAssessmentComponent,
        AddGroupSessionComponent,
        IndividualSessionTableComponent,
        GroupSessionTableComponent,
        AllSessionTablesComponent,
        ViewIndividualAssessmentComponent,
        ViewGroupSessionComponent,
        EditIndividualCounselingComponent,
        EditGroupCounselingComponent,
        EditAssessmentCounselingComponent,
        UpcomingDateAssessmentComponent,
        CounsellingReportDashboardComponent,
        CounsellingIndividualsReportComponent,
        CounsellingGroupSessionComponent,
        CounsellingAssessmentReportComponent,
        CounselingChildReportComponent,
        FollowUpQuestionComponent,
        FollowUpTableComponent,
        ViewFollowUpAssessmentComponent,
        GraphListHorizontalComponent,
        CounsellingSessionReviewListComponent,
      CounsellingSessionReviewComponent,
      WorkUpdateListComponent,
      AddEditWorkUpdateComponent,
      CounsellingSopComponent,
      AddEditGroupSessionTopicsComponent,
      GroupSessionTopicsListComponent,
      ViewGroupSessionTopicsComponent,
      CounsellingInductionTableComponent,
      AddEditCounsellingHighlightsComponent,
      CounsellingHighlightListComponent,
      CounsellingInductionListComponent,
      AddEditInductionComponent,
      AddRowPopUpComponent,
      CounsellingCenterLogComponent,
      AddEditCounsellingCentreLogComponent,
      MomTabsComponent,
      MomCounsellorsComponent,
      MomManagementComponent,
      AddMomCounsellorComponent,
      AddMomManagementComponent,
      EditRemarkDialogComponent,
      ViewCounsellingSessionReviewComponent,
      ViewWorkUpdateComponent,
      MomKavitaComponent,
      AddMomKavitaComponent,
      ViewCounsellingInductionComponent,
      CounsellingPhotoGalleryComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        CounselingRoutingModule,
        PrettyJsonModule,
        NgxMaterialTimepickerModule,
        ComponentsModule,
        MatChipsModule,
        EducationModule
    ],
  exports: [
    GroupSessionTopicsListComponent,
    CounsellingHighlightListComponent,
    CounsellingPhotoGalleryComponent
  ],
    providers: [{provide: FIREBASE_OPTIONS, useValue: environment.firebase}]
})
export class CounselingModule {
}
